import { ToolButton, Tooltip } from '@bst/react-ui';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  toggleColumnsMenu?: MouseEventHandler<HTMLButtonElement>;
  columnMenuActive?: boolean;
  dataTestid?: string
}

export const ColumnMenuTrigger = ({
  toggleColumnsMenu,
  columnMenuActive,
  dataTestid
}: Props) => {
  const { t } = useTranslation();
  return (
    <Tooltip content={t('addRemoveColumns')}>
      <ToolButton
        data-testid={dataTestid}
        isActive={columnMenuActive}
        size="small"
        icon="icon-add-column"
        onClick={toggleColumnsMenu}
        className="rdg-tool-button"
      />
    </Tooltip>
  );
}
